<sui-dialog-simple>
  <ng-template suiDialogHeader>
    <fa-icon [icon]="actionIcon"></fa-icon>
    <h2 ngpDialogTitle>{{ dialogTitle }}</h2>

    <sui-button
      size="sm"
      variant="danger"
      shape="round"
      [leadingIcon]="['fas', 'times']"
      [iconOnly]="true"
      ariaLabel="Close"
      (click)="cancel()"
    ></sui-button>
  </ng-template>

  <ng-template suiDialogContent>
    <div class="json-content">
      @if (isLoading()) {
        <app-loading></app-loading>
      }

      @if (hasError()) {
        <div class="error-state">
          <fa-icon [icon]="icons.warning"></fa-icon>
          <span class="error-message">{{
            "json-viewer.error" | translate
          }}</span>
        </div>
      }

      @if (!isLoading() && !hasError()) {
        @if (hasJson()) {
          @if (pinnedFields().length) {
            <h4 class="section-title">
              {{ "json-viewer.key-details" | translate }}
            </h4>

            <div class="pinned">
              @for (field of pinnedFields(); track field.label) {
                <div class="pinned__field">
                  <label sui-label>{{ field.label }}</label>

                  @if (field.multiline) {
                    <pre class="pinned__block">{{ field.text }}</pre>
                  } @else {
                    <div class="pinned__value">{{ field.text }}</div>
                  }
                </div>
              }
            </div>

            <h4 class="section-title">
              {{ "json-viewer.full-payload" | translate }}
            </h4>
          }

          @if (isTreePayload()) {
            <app-json-tree class="payload" [value]="json()"></app-json-tree>
          } @else {
            <pre class="payload payload--scalar">{{ scalarText() }}</pre>
          }
        } @else {
          <sui-empty-state
            [icon]="icons.inbox"
            [title]="'json-viewer.no-data' | translate"
          ></sui-empty-state>
        }
      }
    </div>
  </ng-template>

  <ng-template suiDialogFooter>
    <sui-button
      size="md"
      variant="primary"
      [leadingIcon]="icons.copy"
      [disabled]="isLoading() || hasError() || !hasJson()"
      (click)="copyToClipboard()"
    >
      {{ "btn.copy" | translate }}
    </sui-button>

    <sui-button size="md" variant="secondary" (click)="cancel()">
      {{ "btn.close" | translate }}
    </sui-button>
  </ng-template>
</sui-dialog-simple>
